import { render } from "./xlptjiancedetail.vue?vue&type=template&id=f85cb560&scoped=true&ts=true"
import script from "./xlptjiancedetail.vue?vue&type=script&lang=ts"
export * from "./xlptjiancedetail.vue?vue&type=script&lang=ts"

import "./xlptjiancedetail.vue?vue&type=style&index=0&id=f85cb560&lang=scss&scoped=true"

import exportComponent from "D:\\ct-construction-ts-mobile\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f85cb560"]])

export default __exports__